import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineInstagram, AiOutlineTwitter } from "react-icons/ai";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import "../../../../src/_Pages/_webapp/HomePageWidgets/Mandi.css";
import { CommonVariables } from "../../../_constants/CommonVariables";
import GetInTouchWithUs from "../../../_Pages/_webapp/HomePageWidgets/GetInTouchWithUs";
import { TiEject } from "react-icons/ti";
// import GetInTouchWithUs from "../../HomePageWidgets/GetInTouchWithUs";
class WebFooter extends React.Component {
  gotoPage = (path) => {
    this.props.history.push(path);
  };

  render() {
    const isMobile = window.matchMedia(
      "only screen and (max-width: 991px)"
    ).matches;

    return (
      <React.Fragment>
        {this.props.GetInTouchWithUs !== undefined &&
        !this.props.GetInTouchWithUs ? (
          ""
        ) : (
          <GetInTouchWithUs />
        )}
        <section
          className={
            "common_Footer " +
            (isMobile ? "tc pdt25b25 fontRoboto lineHt" : "") +
            (this.props.borderTopCss ? " border-top" : "")
          }
        >
          <Container className={isMobile ? "bkgrey pt20 pb20" : ""}>
            <Row>
              <Col className="col-md-4 col-12 mobi-gap">
                <h4>
                  <MultiLanguageTranslation title="Get in Touch" />
                </h4>
                <p className="mb-2">Aryatech Platforms Private Limited</p>
                <p>
                  <span className="footer_label">
                    <MultiLanguageTranslation title="Web" /> :
                  </span>{" "}
                  <a href="https://www.arya.ag" target="_blank">
                    www.arya.ag
                  </a>
                </p>
                <p className="textUnselect">
                  <span className="footer_label">
                    <MultiLanguageTranslation title="Email" /> :
                  </span>{" "}
                  {CommonVariables.arya_email}
                </p>
                <p>
                  <span className="footer_label">
                    <MultiLanguageTranslation title="Phone" /> :
                  </span>
                  <span>
                    <a href="tel:+919015260260">+91 90152 60260</a>
                  </span>
                </p>
                {isMobile ? (
                  <div className="socialLinks socialLinksMobile">
                    <a
                      href="https://www.facebook.com/aryadotag"
                      target="_blank"
                    >
                      <FaFacebookSquare className="socialIcon" />
                    </a>
                    <a href="https://twitter.com/aryadotag" target="_blank">
                      <AiOutlineTwitter className="socialIcon" />
                    </a>
                    <a
                      href="https://www.instagram.com/aryadotag/"
                      target="_blank"
                    >
                      <AiOutlineInstagram className="socialIcon" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/aryadotag/"
                      target="_blank"
                    >
                      <FaLinkedin className="socialIcon" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCIM_C6FrdqGjfQjrY4fNRSw"
                      target="_blank"
                    >
                      <IoLogoYoutube className="socialIcon" />
                    </a>
                  </div>
                ) : (
                  <div className="socialLinks">
                    <a
                      href="https://www.facebook.com/aryadotag"
                      target="_blank"
                    >
                      <FaFacebookSquare className="socialIcon" />
                    </a>
                    <a href="https://twitter.com/aryadotag" target="_blank">
                      <AiOutlineTwitter className="socialIcon" />
                    </a>
                    <a
                      href="https://www.instagram.com/aryadotag/"
                      target="_blank"
                    >
                      <AiOutlineInstagram className="socialIcon" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/aryadotag/"
                      target="_blank"
                    >
                      <FaLinkedin className="socialIcon" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCIM_C6FrdqGjfQjrY4fNRSw"
                      target="_blank"
                    >
                      <IoLogoYoutube className="socialIcon" />
                    </a>
                  </div>
                )}
              </Col>
              <Col className="col-md-4 col-12 mobi-gap">
                <h4>
                  <MultiLanguageTranslation title="Address" />
                </h4>
                <p className="mb-2">Aryatech Platforms Private Limited</p>
                <p>
                  <MultiLanguageTranslation title="H 82, Sector 63" />
                  <br />
                  <MultiLanguageTranslation title="Noida 201301 UP INDIA" />
                </p>
                <p>
                  <span className="redressal">
                    <MultiLanguageTranslation title="Grievance Redressal Officer" />
                  </span>
                  <br />
                  <MultiLanguageTranslation title="Nitendra Gupta" /> -
                  <a style={{ color: "#202020" }} href="tel:01204859319">
                    0120-4859319
                  </a>{" "}
                </p>
              </Col>
              {isMobile ? (
                <Col className="col-md-4 col-12 fw500 menuSec d-flex jceven flexWrap fs14">
                  <Link className="clrblk pr10" to="/">
                    <MultiLanguageTranslation title="Home" />
                  </Link>
                  <Link className="clrblk pr10" to="/our-story">
                    <MultiLanguageTranslation title="About Us" />
                  </Link>
                  <Link className="clrblk pr10" to="/our-services">
                    <MultiLanguageTranslation title="Our Services" />
                  </Link>
                  <Link className="clrblk pr10" to="/news-update">
                    <MultiLanguageTranslation title="Media Coverage" />
                  </Link>
                  <Link className="clrblk pr10" to="/WhoWeServe">
                    <MultiLanguageTranslation title="Who We Serve" />
                  </Link>
                  <Link className="clrblk pr10" to="/contact-us">
                    <MultiLanguageTranslation title="Contact Us" />
                  </Link>
                </Col>
              ) : (
                <Col className="col-md-4 col-12 menuSec">
                  <ul className="list-inline">
                    <li>
                      <Link to="/">
                        <MultiLanguageTranslation title="Home" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-story">
                        <MultiLanguageTranslation title="About Us" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services">
                        <MultiLanguageTranslation title="Our Services" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/news-update">
                        <MultiLanguageTranslation title="Media Coverage" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/WhoWeServe">
                        <MultiLanguageTranslation title="Who We Serve" />
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us">
                        <MultiLanguageTranslation title="Contact Us" />
                      </Link>
                    </li>
                  </ul>
                </Col>
              )}
              <Col
                className="col-md-4 col-12 menuSec"
                style={{ display: "none" }}
              >
                <ul className="list-inline">
                  <li>
                    <a href="#">
                      <MultiLanguageTranslation title="Press & News" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <MultiLanguageTranslation title="Research & Insights" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <MultiLanguageTranslation title="Arya Updates" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <MultiLanguageTranslation title="Contact Us" />
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
          <div className={!isMobile ? "privacySec" : ""}>
            <Container>
              {isMobile ? (
                <Row>
                  <Col className="col-md-4 terms col-12 bordbotgrey p10">
                    <a
                      className="pr10"
                      onClick={() => this.gotoPage("/terms-condition")}
                    >
                      <MultiLanguageTranslation title="Terms and Conditions" />
                    </a>
                    <a onClick={() => this.gotoPage("/privacy-policy")}>
                      <MultiLanguageTranslation title="Privacy" />
                    </a>
                  </Col>
                  <Col className="col-md-8 links col-12 pt10 bordbotgrey p10">
                    <div>
                      <div>
                        <MultiLanguageTranslation title="Useful links" />:
                      </div>
                      <a
                        className="fs12 pr40"
                        href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299688.pdf"
                        target="_blank"
                      >
                        <MultiLanguageTranslation title="KYC AML Policy Aryadhan" />
                      </a>
                      <a
                        className="fs12"
                        href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299731.pdf"
                        target="_blank"
                      >
                        <MultiLanguageTranslation title="Fair Practice Code Aryadhan" />
                      </a>
                      <div>
                        <a
                          className="pl10 fs12"
                          href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299762.pdf"
                          target="_blank"
                        >
                          <MultiLanguageTranslation title="Privacy Policy Aryadhan" />
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col className="col-md-4 terms col-12">
                    <a onClick={() => this.gotoPage("/terms-condition")}>
                      <MultiLanguageTranslation title="Terms and Conditions" />
                    </a>
                    <a onClick={() => this.gotoPage("/privacy-policy")}>
                      <MultiLanguageTranslation title="Privacy" />
                    </a>
                  </Col>
                  <Col className="col-md-8 links col-12">
                    <div>
                      <span>
                        <MultiLanguageTranslation title="Useful links" />:
                      </span>
                      <a
                        href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299688.pdf"
                        target="_blank"
                      >
                        <MultiLanguageTranslation title="KYC AML Policy Aryadhan" />
                      </a>
                      <a
                        href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299731.pdf"
                        target="_blank"
                      >
                        <MultiLanguageTranslation title="Fair Practice Code Aryadhan" />
                      </a>
                      <a
                        href="https://a2z-web.s3.ap-south-1.amazonaws.com/arya/warehouseRequests/file_1618299762.pdf"
                        target="_blank"
                      >
                        <MultiLanguageTranslation title="Privacy Policy Aryadhan" />
                      </a>
                    </div>
                  </Col>
                </Row>
              )}
            </Container>
          </div>
          <Container>
            <div className="copyright">
              <p>
                <MultiLanguageTranslation title="Copyright" /> ©{" "}
                {new Date().getFullYear()} Aryatech Platforms Private Limited.{" "}
                <MultiLanguageTranslation title="All Rights Reserved" />.{" "}
              </p>
            </div>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
export default withRouter(WebFooter);
